import { HookError } from 'components/ErrorBoundary';
import { ACTIONS } from 'constants/hook';
import { isDebugMode } from 'utils/debug';
import { getIsNativeMobileApp } from 'utils/mobile';
import { AppConfigReducerActionType, AppConfigStateType } from './types';

export const initialState: AppConfigStateType = {
  isDebugMode: isDebugMode(),
  isEnabled: true,
  isNativeMobileApp: getIsNativeMobileApp(),
  referrer: undefined,
  experiments: {},
};

export const appConfigReducer = (state: AppConfigStateType, action: AppConfigReducerActionType) => {
  switch (action.type) {
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
